import { render, staticRenderFns } from "./AdminEditShopProduct.vue?vue&type=template&id=87fdc360&scoped=true&"
import script from "./AdminEditShopProduct.vue?vue&type=script&lang=js&"
export * from "./AdminEditShopProduct.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditShopProduct.vue?vue&type=style&index=0&id=87fdc360&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fdc360",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87fdc360')) {
      api.createRecord('87fdc360', component.options)
    } else {
      api.reload('87fdc360', component.options)
    }
    module.hot.accept("./AdminEditShopProduct.vue?vue&type=template&id=87fdc360&scoped=true&", function () {
      api.rerender('87fdc360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminEditShopProduct.vue"
export default component.exports